import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Portfolio() {
  const navigate = useNavigate();

  const projects = [
    {
      id: 'e-commerce-platform',
      title: 'E-Commerce Platform',
      category: 'Web Development',
      image: 'https://images.unsplash.com/photo-1557821552-17105176677c?w=800&h=600&fit=crop',
      description: 'A full-featured e-commerce platform with AI-powered recommendations and real-time analytics.',
      gradient: 'from-green-500 to-emerald-600',
    },
    {
      id: 'finance-mobile-app',
      title: 'Finance Mobile App',
      category: 'Mobile Development',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=600&fit=crop',
      description: 'Secure financial management app with biometric authentication and real-time updates.',
      gradient: 'from-blue-500 to-indigo-600',
    },
    {
      id: 'healthcare-dashboard',
      title: 'Healthcare Dashboard',
      category: 'Data Analytics',
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&h=600&fit=crop',
      description: 'Comprehensive healthcare analytics dashboard with interactive visualizations.',
      gradient: 'from-purple-500 to-pink-600',
    },
    {
      id: 'smart-home-system',
      title: 'Smart Home System',
      category: 'IoT Solutions',
      image: 'https://images.unsplash.com/photo-1558002038-1092e50bb7b6?w=800&h=600&fit=crop',
      description: 'AI-powered smart home automation system with voice control and energy monitoring.',
      gradient: 'from-yellow-500 to-orange-600',
    },
    {
      id: 'education-platform',
      title: 'Education Platform',
      category: 'Web Development',
      image: 'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&h=600&fit=crop',
      description: 'Interactive learning platform with AI tutoring and personalized curriculum.',
      gradient: 'from-red-500 to-rose-600',
    },
    {
      id: 'logistics-tracker',
      title: 'Logistics Tracker',
      category: 'Mobile Development',
      image: 'https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=800&h=600&fit=crop',
      description: 'Real-time logistics tracking app with predictive delivery analytics.',
      gradient: 'from-teal-500 to-cyan-600',
    },
  ];

  const handleViewDetails = (projectId) => {
    navigate(`/project/${projectId}`);
  };

  const handleCaseStudy = (projectId) => {
    navigate(`/case-study/${projectId}`);
  };

  const handleViewAllProjects = () => {
    navigate('/portfolio');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section id="portfolio" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-24">
          <div className="inline-block bg-white px-6 py-3 rounded-full shadow-sm mb-6">
            <span className="text-green-600 font-semibold">Our Work</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-6">
            Featured <span className="text-gradient">Projects</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Explore our portfolio of successful projects that showcase our expertise and commitment to excellence.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 tilt-hover reveal-element"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="relative overflow-hidden group">
                <img 
                  src={project.image} 
                  alt={project.title} 
                  className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${project.gradient} opacity-0 group-hover:opacity-90 transition-opacity duration-500 flex items-center justify-center`}>
                  <button 
                    onClick={() => handleViewDetails(project.id)}
                    className="bg-white text-gray-900 px-6 py-3 rounded-full font-semibold transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300 hover:bg-gray-100"
                  >
                    View Details
                  </button>
                </div>
              </div>
              <div className="p-8">
                <span className="inline-block bg-gray-100 text-green-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
                  {project.category}
                </span>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{project.title}</h3>
                <p className="text-gray-600 leading-relaxed mb-6">{project.description}</p>
                <button 
                  onClick={() => handleCaseStudy(project.id)}
                  className="text-green-600 font-semibold hover:text-green-700 transition-colors flex items-center gap-2 group"
                >
                  <span>Case Study</span>
                  <i className="fas fa-arrow-right transform group-hover:translate-x-1 transition-transform"></i>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-24">
          <button 
            onClick={handleViewAllProjects}
            className="bg-gray-100 text-gray-800 px-8 py-4 rounded-full font-semibold hover:bg-gray-200 transition-all inline-flex items-center gap-2"
          >
            View All Projects
            <i className="fas fa-th-large"></i>
          </button>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;